import { useState } from "react";
import { Copy } from "lucide-react";
import type { Session } from "@training/shared";
import { copyText } from "../lib/copy.ts";
import { notify } from "../lib/notify.ts";
import { sessionRecap } from "../lib/recap.ts";
import type { Entry } from "../lib/session.ts";

/**
 * The session's sets as text, for Whoop's assistant: it sees the workout but
 * not what was lifted, and screenshots of the list were the only way to tell
 * it. When the browser refuses the copy, the text shows instead, to select
 * by hand.
 */
export function SessionRecap({ session, entries }: { session: Session; entries: Entry[] }) {
  const [shown, setShown] = useState(false);
  const text = sessionRecap(session, entries);

  const copy = async () => {
    if (await copyText(text)) {
      navigator.vibrate?.(25);
      notify("Séance copiée : à coller dans Whoop.");
    } else {
      setShown(true);
      notify("Copie refusée par le navigateur : sélectionner le texte.", "error");
    }
  };

  return (
    <div className="mt-4 border-t border-line/60 pt-3">
      <button
        type="button"
        onClick={() => void copy()}
        className="flex w-full items-center gap-4 text-left active:opacity-70"
      >
        <span className="min-w-0 flex-1">
          <span className="label block">Copier pour Whoop</span>
          <span className="mt-0.5 block text-[0.78rem] text-ink-mute">Chaque série en toutes lettres.</span>
        </span>
        <Copy size={18} className="shrink-0 text-ink-soft" aria-hidden />
      </button>
      {shown && (
        <textarea
          readOnly
          value={text}
          aria-label="Texte de la séance"
          rows={10}
          onFocus={(event) => event.currentTarget.select()}
          className="mt-3 w-full rounded-lg border border-line bg-surface p-3 text-[16px] leading-snug text-ink-soft"
        />
      )}
    </div>
  );
}
